import { images } from '../images';

// Extra content for the General English course page (alternative layout).
export const generalEnglishPage = {
  details: [
    'Learn English in a welcoming environment that encourages real communication. Our General English course builds confidence in all four language skills — speaking, listening, reading and writing — through lessons connected to everyday life.',
    'Whether you are just starting your English journey or already know a lot and want to advance, you join a class at your level and study topics you meet every day: work, travel, health, food and the city around you.',
    'Beyond the classroom, our social programme lets you explore the city, meet friends from many nationalities and use your English naturally in daily situations.',
  ],
  // Paste a YouTube or Vimeo embed URL here, e.g. 'https://www.youtube.com/embed/VIDEO_ID'. Leave empty to show the placeholder.
  video: {
    url: '',
    poster: images.classroom,
    title: 'Inside a General English class',
    caption: 'Meet our teachers, step into a lesson and see what a day at ES World looks like.',
  },
  intensities: [
    { name: 'Intensive', lessons: 'Dubai 30 · London 40 a week', text: 'About 6 weeks per level, for the fastest progress.' },
    { name: 'Semi-intensive', lessons: 'Dubai 15 · London 20 a week', text: 'About 12 weeks per level, with time to work or explore.' },
  ],
  skills: [
    { name: 'Speaking', text: 'Pair work, role plays and discussions in every lesson.' },
    { name: 'Listening', text: 'Real conversations, podcasts and videos at natural speed.' },
    { name: 'Reading', text: 'Real-world texts from National Geographic Learning’s Life series.' },
    { name: 'Writing', text: 'Messages, emails and short texts with teacher feedback.' },
  ],
  campuses: [
    {
      slug: 'dubai',
      highlight: 'Two campuses in JLT and JBR with smart classrooms, morning, midday and late-afternoon timetables, and 20+ social activities a month across the city.',
    },
    {
      slug: 'london',
      highlight: 'Study in Bloomsbury, near King’s Cross, with CELTA-qualified teachers, an average class of 14 and a social programme that turns London into your classroom.',
    },
  ],
};
